import { useParams } from 'react-router-dom';
import { GenerateTestDataButton } from './GenerateTestDataButton';
import { generateTestCustomerSubscriptions } from '../utils/customerSubscriptionsGenerator';

export const GenerateCustomerSubscriptionsButton = () => {
  const { id: customerId } = useParams();
  const generateFunction = (count: number) => generateTestCustomerSubscriptions(count, customerId);

  return (
    <GenerateTestDataButton 
      label="Generate Subscriptions" 
      generateFunction={generateFunction} 
      queryKey={['customer-subscriptions']} 
    />
  );
};